<div fxLayout="column" class="container gap-12">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <h1 class="text-16-semi-bold color-text-primary">Editar Indicadores</h1>
        <dsn-button-rounded
            [type]="'secondary'"
            [icon]="'fa-solid fa-xmark'"
            (onClick)="dialogRef.close()"
        ></dsn-button-rounded>
    </div>
    <div fxLayout="column" class="indicators-box gap-16">
        <div fxLayout="column" class="gap-8">
            <h2 class="text-14-semi-bold color-text-primary">Nome do Dash</h2>
            <div
                fxLayout="row"
                fxLayoutAlign="space-between center"
                class="gap-32"
            >
                <dsn-input
                    [size]="'medium'"
                    [type]="'text'"
                    [placeholder]="'Nome do Dash'"
                    [noValidate]="true"
                    fxFlex
                    [(ngModel)]="reportName"
                    [(inputRef)]="reportNameInput"
                    [disabled]="loading"
                ></dsn-input>
                <dsn-button-rounded
                    [type]="'secondary'"
                    [icon]="'fa-solid fa-pencil'"
                    [disabled]="loading"
                    (onClick)="onEditReportName()"
                ></dsn-button-rounded>
            </div>
        </div>
        <dsn-input
            [size]="'medium'"
            [type]="'text'"
            [placeholder]="'Pesquisar Indicador'"
            [noValidate]="true"
            [value]="visualizationNameFilter"
            (onValueChange)="onVisualizationNameFilterChange($event)"
            fxFlex
        ></dsn-input>
        <ul class="indicators-list dsn-scrollbar overflow-y">
            @for (visualization of filteredVisualizations; track $index) {
                <li>
                    <dsn-checkbox
                        [label]="visualization.props.name"
                        [disabled]="loading"
                        [fontWeight]="'semi-bold'"
                        [checkedValue]="isVisible(visualization)"
                        [useNgModel]="false"
                        (handleValueChange)="
                            onCheckboxValueChange(visualization)
                        "
                    ></dsn-checkbox>
                    <span fxFlex></span>
                    <span class="indicator-source-badge">{{
                        visualization.sourceLabel
                    }}</span>
                </li>
            }
        </ul>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center" class="gap-16">
        <dsn-button
            label="Cancelar"
            type="outline"
            size="medium"
            [disabled]="loading"
            (onClick)="dialogRef.close()"
        ></dsn-button>
        <dsn-button
            label="Salvar alterações"
            type="primary"
            size="medium"
            [disabled]="loading || !reportName"
            (onClick)="onSaveChanges()"
        ></dsn-button>
    </div>
</div>
